// @ts-check
import { ref } from 'vue'
import { isGenderNum } from '@/studentsite/signup/signup/guard'

/**
 * @import { Ref } from 'vue'
 * @import { RelayParams } from '../../guard.js'
 */

/**
 * @param {Ref<HTMLFormElement|undefined>} refForm
 * @returns
 */
export const setup = refForm => {
  const oldFirstName = /** @type {HTMLInputElement|null} */ (document.getElementById('old_first_name'))?.value ?? ''
  const oldLastName = /** @type {HTMLInputElement|null} */ (document.getElementById('old_last_name'))?.value ?? ''
  const oldGender = Number(/** @type {HTMLInputElement|null} */ (document.getElementById('old_gender'))?.value ?? '1')
  const oldTelNo = /** @type {HTMLInputElement|null} */ (document.getElementById('old_tel'))?.value ?? ''
  const oldLoginId = /** @type {HTMLInputElement|null} */ (document.getElementById('old_login_id'))?.value ?? ''

  /** @type {Ref<RelayParams|undefined>} */
  const relayParams = ref({
    first_name: oldFirstName,
    last_name: oldLastName,
    gender: isGenderNum(oldGender) ? oldGender : 1,
    tel: oldTelNo,
    login_id: oldLoginId,
    login_password: '',
  })

  /**
   * @param {RelayParams} param
   */
  const setParam = param => {
    relayParams.value = param
  }

  const submit = () => {
    refForm.value?.submit()
  }

  return {
    relayParams,
    setParam,
    submit,
  }
}
